export default __webpack_public_path__ + "6423ea22ac10bfa6996c6f9db9b0ad1d.svg";